import * as React from "react";
import type { SVGProps } from "react";
const SvgCustomers = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20" {...props}
  >
    <path
      stroke="#858993"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M17.327 7.936a1.686 1.686 0 1 1-2.384 2.384 1.686 1.686 0 0 1 2.384-2.384M11.835 4.927a2.596 2.596 0 1 1-3.671 3.671 2.596 2.596 0 0 1 3.671-3.671M5.057 7.936a1.686 1.686 0 1 1-2.384 2.384 1.686 1.686 0 0 1 2.384-2.384M19.167 15.833v-.913c0-1.15-.933-2.083-2.084-2.083h-.667M.833 15.833v-.913c0-1.15.933-2.083 2.084-2.083h.667M14.45 15.833V14.5a2.917 2.917 0 0 0-2.917-2.917H8.467A2.917 2.917 0 0 0 5.55 14.5v1.334"
    />
  </svg>
);
export default SvgCustomers;
